import { getTokens } from 'core/classes/helpers/StorageHelper'
import settings from 'src/config/settings'

interface ISyncMdfActivitiesParams {
  partnerId: string
  fYear: number
}

export const syncMdfActivities = async ({
  partnerId,
  fYear,
}: ISyncMdfActivitiesParams): Promise<void> => {
  const url = `${settings.httpsServices.partner360}/api/v0/mdf/syncMdfActivities`
  const [accessToken] = getTokens()

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: JSON.stringify({
      fiscalYear: fYear,
      partnerId,
      apiVersion: 'v1',
    }),
  })

  if (!response.ok) {
    throw new Error(`MDF activities sync request failed with status ${response.status}`)
  }
}
